import Http from "./Http";

export class LocationsListsService extends Http {
  /**
   * Get countries
   */
  getCountries() {
    return this.get(`/ccbill/countries`);
  }
  /**
   * Get cities
   * @param {string} params.countyCode
   */
  getCities(params) {
    return this.get(`/ccbill/countries/${params.countryCode}/areas`);
  }
}

LocationsListsService.$displayName = "LocationsListsService";

export default new LocationsListsService();
